class PdpUpsells extends HTMLElement {
  constructor() {
    super();

    this.upsellProducts = this.querySelectorAll(".pdp-upsells .pdp-upsells_product");
    this.accordionButton = this.querySelector(".pdp-upsells .accordion-trigger");
    this.accordionButtonContent = this.querySelector(".pdp-upsells .accordion-trigger span:not(.animated-icon-plus)");
    this.accordionContent = this.querySelector(".pdp-upsells .accordion-content");

    this.checkboxes = this.querySelectorAll(".pdp-upsells input[type='checkbox']");
    this.productsToAdd = 1; // initially setting to 1 as per main product

    this.AtcButton = document.querySelector(".pdp-buy-buttons product-form .product-form__submit span");
    this.StickyAtcButton = document.querySelector(".sticky-atc-button__submit span");

    console.log(this.AtcButton)

    console.log(this.checkboxes)

    this.accordionCopyMore = this.dataset.accordionCopyMore;
    this.accordionCopyLess = this.dataset.accordionCopyLess;
    this.addCopy = this.dataset.add;
    this.itemsToBagCopy = this.dataset.itemsToBag;
    this.defaultAtcCopy = this.dataset.defaultAtc;

  }

  connectedCallback() {
    this.upsellProducts.forEach((product) => {
      product.addEventListener("click", (e) => {
        this.handleSwatchChange.bind(this)(e);
      });
    });

    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", (e) => {
        this.handleCheckboxes.bind(this)(e);
      });
    });

    if (this.accordionButton === null) return;
    this.accordionButton.addEventListener("click", (e) => {
      this.handleAccordionClick.bind(this)(e);
    });
  }

  handleSwatchChange(e) {
    const clickedEl = e.target;

    if(!clickedEl.classList.contains("colour-circle")) return;

    const parentEl = clickedEl.closest(".pdp-upsells_product");
    const allSwatchesEl = parentEl.querySelectorAll(".colour-circle");

    const imageEl = parentEl.querySelector(".upsell-media img");
    const titleEl = parentEl.querySelector(".upsell-title");
    const priceEl = parentEl.querySelector(".upsell-price");
    const compareAtPriceEl = parentEl.querySelector(".upsell-price.compare-at");

    const productImage = clickedEl.dataset.featuredImage;
    const productTitle = clickedEl.dataset.productTitle;
    const productPrice = clickedEl.dataset.productPrice;
    const productCompareAtPrice = clickedEl.dataset.productCompareAtPrice;
    const shouldShowCompareAtPrice = clickedEl.dataset.shouldShowCompareAtPrice === "true";

    allSwatchesEl.forEach((swatch) => {
      swatch.classList.remove("selected");
    });
    clickedEl.classList.add("selected");

    imageEl.src = productImage;
    imageEl.srcset = productImage;
    titleEl.innerHTML = productTitle;
    priceEl.innerHTML = productPrice;
    if (shouldShowCompareAtPrice) {
      compareAtPriceEl.innerHTML = productCompareAtPrice;
      compareAtPriceEl.classList.remove("hidden");
    } else {
      compareAtPriceEl.classList.add("hidden");
    }
  }

  handleCheckboxes(e) {
    if (e.target.checked == true) {
      this.productsToAdd++;
    } else {
      this.productsToAdd--;
    }

    if (this.productsToAdd > 1) {
      this.AtcButton.innerHTML = `${this.addCopy}${this.productsToAdd}${this.itemsToBagCopy}`;
      this.StickyAtcButton.innerHTML = `${this.addCopy}${this.productsToAdd}${this.itemsToBagCopy}`;
    } else {
      this.AtcButton.innerHTML = this.defaultAtcCopy;
      this.StickyAtcButton.innerHTML = this.defaultAtcCopy;
    }

  }

  handleAccordionClick() {

    const ariaExpanded = this.accordionButton.getAttribute("aria-expanded");
    if (ariaExpanded === "false") {
        this.accordionButton.setAttribute("aria-expanded", "true");
        this.accordionContent.setAttribute("aria-hidden", "false");
        this.accordionButtonContent.innerHTML = this.accordionCopyLess;
    } else {
        this.accordionButton.setAttribute("aria-expanded", "false");
        this.accordionContent.setAttribute("aria-hidden", "true");
        this.accordionButtonContent.innerHTML = this.accordionCopyMore;
    }
  }
}

customElements.define("pdp-upsells", PdpUpsells);
